import React from 'react';
import socketIOClient from 'socket.io-client';
import { useDispatch } from 'react-redux';
import * as providerActions from 'app/store/actions/providers';
import * as authActions from 'app/auth/store/actions';
import { updateSessionCapacityFromSocket } from 'app/store/actions/sessions.actions';
import { API_BASE_URL } from '@config';
import decode from 'jwt-decode';
import * as ActionsDialog from 'app/store/actions';
import TrainingLogoutDialog from 'app/main/trainings/components/TrainingLogoutDialog';
import { Fade } from '@material-ui/core';

function SocketCliente() {
	const dispatch = useDispatch();
	const socket = socketIOClient(API_BASE_URL, {
		transports: ['websocket', 'polling', 'flashsocket'],
		query: { token: window.localStorage.getItem('token') }
	});

	socket.on('connect', () => {
		dispatch(providerActions.setConnect('con'));
		dispatch(providerActions.setChangeDbClusters(true));
		dispatch(providerActions.setChangeDbNodes(true));
		dispatch(providerActions.setChangeDbQueuedjob(true));
		dispatch(providerActions.setChangeDbClusterHealth(true));
	});

	socket.on('disconnect', data => {
		dispatch(providerActions.setConnect('dis'));
	});

	socket.on('change', data => {
		if (data.changed === 'clusters') {
			dispatch(providerActions.setChangeDbClusters(true));
		}
		if (data.changed === 'nodes') {
			dispatch(providerActions.setChangeDbNodes(true));
		}
		if (data.changed === 'queuedjobs') {
			dispatch(providerActions.setChangeDbQueuedjob(true));
		}
		if (data.changed === 'clusterhealths') {
			dispatch(providerActions.setChangeDbClusterHealth(true));
		}
		if (data.changed === 'commissionedmachines') {
			dispatch(providerActions.setChangeDbCommissionedMachines(true));
		}
	});

	socket.on('capacity:update', (data) => {
		dispatch(updateSessionCapacityFromSocket(data));
	});

	socket.on('trainingSessionIsEnding', data => {
		const { sessionCode, trainingId } = data;
		if (!sessionCode && !trainingId) return;
		try {
			const savedSessionCode = decode(window.localStorage.getItem('token')).user.sessionCode
			const savedTrainingId = decode(window.localStorage.getItem('token')).user.trainingId
			if (!savedSessionCode && !savedTrainingId) return;
			if (sessionCode === savedSessionCode || trainingId === savedTrainingId) {
				dispatch(authActions.logoutUser());
				dispatch(ActionsDialog.openDialog({
					children: (<TrainingLogoutDialog onClose={() => dispatch(ActionsDialog.closeDialog())} />),
					maxWidth: false,
					fullWidth: false,
					TransitionComponent: Fade,
					transitionDuration: 400,
					PaperProps: { style: { backgroundColor: 'transparent', boxShadow: 'none' } },
					BackdropProps: { style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } }
				}));
			}
		} catch (error) {
			console.error(error);
			return;
		}
	});

	socket.on('publicDemoSessionIsEnding', data => {
		const token = window.localStorage.getItem('token');
		if (!token) return;
		const user = decode(token)?.user;
		if (!user) return;
		const signedInUsername = user.username;
		if (!signedInUsername) return;
		try {
			if (data.username === signedInUsername) {
				dispatch(authActions.logoutUser());
				dispatch(ActionsDialog.openDialog({
					children: (<TrainingLogoutDialog onClose={() => dispatch(ActionsDialog.closeDialog())} />),
					maxWidth: false,
					fullWidth: false,
					TransitionComponent: Fade,
					transitionDuration: 400,
					PaperProps: { style: { backgroundColor: 'transparent', boxShadow: 'none' } },
					BackdropProps: { style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } }
				}));
			}
		} catch (error) {
			console.error(error);
			return;
		}
	});

	socket.on('silentLogout', (data) => {
		const token = window.localStorage.getItem('token');
		if (!token) return;

		const user = decode(token)?.user;
		if (!user) return;

		const signedUser = user.email;
		if (!signedUser) return;
		if (data.username === signedUser) {
			dispatch(authActions.logoutUser());
		}
	});

	return socket;
}

export default SocketCliente;
